<template>
    <div id="codes_list_component"
         class="codes-list-component">
        <p style="margin-bottom: 11px">Your vouchers</p>
        <div class="codes-list-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                        <tr>
                            <th><p>No:</p></th>
                            <th><p>Voucher:</p></th>
                            <th><p>Value:</p></th>
                            <th><p>Status:</p></th>
                            <th><p>Create Date:</p></th>
                            <th><p>Reason reject:</p></th>
                            <th><p>Actions:</p></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="codes.length == 0">
                            <th colspan="7">You don't have any vouchers yet</th>
                        </tr>
                        <tr v-for="(code, index) in codes" :key="code.codeId">
                            <td><p>{{ rowNumber(index) }}</p></td>
                            <td><p>{{ code.code }}</p></td>
                            <td><p>FND {{ money.format(code.value, 'fnd') }}</p></td>
                            <td><p>{{ codeStatus(code) }}</p></td>
                            <td><p>{{ code.createdAt }}</p></td>
                            <td><p>{{ code.reason ? code.reason : '-' }}</p></td>
                            <td>
                                <button class="button--primary" @click="cancelCode(code)" v-if="code.status == 'new'">Cancel</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    export default {
        dependencies: ['code', 'money'],
        data () {
            return {
                items: 25
            };
        },
        computed: {
            currentPage () {
                return this.$store.getters.listSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.listSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.listSettings.numberOfPages;
            },
            loader() {
                return this.$store.getters.codes.isListLoading;
            },
            codes () {
                return this.$store.getters.codes.list;
            },
            settings () {
                return this.$store.getters.listSettings;
            }
        },
        methods: {
            /**
             * Get data with transactions
             */
            getData () {
                this.code.fetchList(this.settings);
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('listSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('listSetPage', page).then(() => {
                    this.getData();
                    window.scrollTo(0,0);
                });
            },

            /**
             * Get row number
             */
            rowNumber (index) {
                return ((this.currentPage - 1) * this.maxPerPage) + index + 1;
            },

            /**
             * Code status
             * @param code
             */
            codeStatus(code) {
                return code.status.replace(/_/g, ' ');
            },

            /**
             * Cancel code
             * @param code
             */
            cancelCode(code) {
                this.code.cancelCode(code);
                this.setPage(1);
                this.getData();
            }
        },
        mounted () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/codes/CodesList.vue